import useAPI, { useAPIMutation } from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";
import { AccountData } from "./types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/services/auth/AuthContext";
import { useQueryClient } from "@tanstack/react-query";

export const useAccount = (): ExtendedUseQueryResult<AccountData> => {
  const result = useAPI("accounts");
  const { user } = useAuth();
  const navigate = useNavigate();
  const userId = user?.email || "unknown";

  useEffect(() => {
    if (result.error) {
      console.error("Failed to fetch account data:", result.error);
      if (result.error.message === "ERR_BAD_RESPONSE") {
        navigate({ pathname: "/loginErrorPage", search: `?user=${userId}` });
      }
    }
  }, [result.error, userId]);

  return result;
};

export const useUpdateAccountDataByKey = () => {
  const queryClient = useQueryClient();

  return useAPIMutation<
    {
      data: Partial<AccountData>;
    },
    AccountData
  >(
    "accounts",
    {
      method: "PUT"
    },
    () => queryClient.invalidateQueries({ queryKey: ["accounts"] })
  );
};

export default useAccount;
